// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","submitContainer":"_1udyAO1WivpVcbodahEWQF","error":"_3zd_FcXjrJcoHq_-rVj1Bn","serverError":"_14E0kIuI8aEHnEM1YdFIg9","msg":"_PnB7cAY-lSOvdlXKlE0K"};